import { FC } from "react";
import { Route, Routes } from "react-router-dom";
import { EmployeeDetailsPage } from "~root/employees/details/EmployeeDetailsPage";
import { DefaultContentLayout, DetailsPageContentLayout } from "~shared/layout";
import { EmployeeList } from "./EmployeeList";

export const EmployeePage: FC = () => {
	return (
		<Routes>
			<Route
				index
				element={
					<DefaultContentLayout>
						<EmployeeList />
					</DefaultContentLayout>
				}
			/>
			<Route path=":id/*">
				<Route
					path="*"
					index
					element={
						<DetailsPageContentLayout>
							<EmployeeDetailsPage />
						</DetailsPageContentLayout>
					}
				></Route>
			</Route>
		</Routes>
	);
};
